export type AppointmentInput = {
  id: string;
  orderID: string;
  driver: string;
  facilityID: string;
  date: string;
  time: string;
  type: string;
  tenantID: string;
};

export async function createAppointment(appointmentData: AppointmentInput) {
  const formattedData = {
    body: JSON.stringify(appointmentData),
  };

  console.log('🛰 createAppointment called with:', appointmentData);

  const response = await fetch(
    'https://yhc75qpqp6.execute-api.us-east-2.amazonaws.com/prod/create-apppointment',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formattedData),
    }
  );

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  const data = await response.json();
  return data;
}

export async function deleteAppointment(id: string): Promise<void> {
  const formattedData = { body: JSON.stringify({ id }) };
  const response = await fetch(
    'https://yhc75qpqp6.execute-api.us-east-2.amazonaws.com/prod/delete-appointment',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formattedData),
    },
  );
  if (!response.ok) throw new Error('Failed to delete appointment');
}
